import BinanceTickerWrapper from './BinanceTickerBarStyles';
interface Props {
  className: string;
}

const BinanceTickerBar = ({ className }: Props) => (
  <BinanceTickerWrapper
    className={`binance-widget-marquee ${className}`}
    data-cmc-ids='1,1027,52,5426,3408,74,2010,20947,5994,24478,13502,35336'
    data-theme='light'
    data-transparent='false'
    data-locale='en'
    data-powered-by='Powered by'
    data-disclaimer='Disclaimer'
    data-cy='ticker'
  />
);

export default BinanceTickerBar;
